import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import { formatCadenceTimeOnly } from 'app/helpers'

dayjs.extend(customParseFormat)

// Short timings for a batch, e.g. "9:00am-1:00pm". Shared by the enrolment
// form and the Active Care link dialogs.
export const batchTimingsShortLabel = (batch) => {
  const fromCadence = formatCadenceTimeOnly(batch?.cadence)
  if (fromCadence) return fromCadence

  const { start_time: st, end_time: et } = batch || {}
  if (st && et) {
    const start = dayjs(st, ['HH:mm:ss', 'HH-mm'], true)
    const end = dayjs(et, ['HH:mm:ss', 'HH-mm'], true)
    if (start.isValid() && end.isValid()) {
      return `${start.format('h:mma')}-${end.format('h:mma')}`
    }
    return `${st} - ${et}`
  }

  if (Array.isArray(batch?.timings) && batch.timings.length > 0) {
    return batch.timings.join(' · ')
  }

  return ''
}
